import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

export default function LinearBuffer(props) {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const { t } = useTranslation();

    const progressRef = React.useRef(() => { });

    useEffect(() => {
        if (props.status == 'EXECUTED' || props.status == 'REJECTED' || props.stats == 'EXCEPTION') {
            setProgress(100);
            setBuffer(100);
        } else {
            progressRef.current = () => {
                if (progress > 100) {
                    setProgress(0);
                    setBuffer(10);
                } else {
                    const diff = Math.random() * 10;
                    const diff2 = Math.random() * 10;
                    setProgress(progress + diff);
                    setBuffer(progress + diff + diff2);
                }
            };
        }
    });

    useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <Grid item xs={12} paddingX={2} paddingY={2}>
            <Typography variant="subtitle2" margin={1}>{t('subscription_processing')}</Typography>
            <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
        </Grid>
    );
}